import React from "react";
import { Button } from "antd";
import SectionHeader from "./SectionHeader";
import ScrollCarousel from "./ScrollCarousel";
import { DEALS } from "../mock";

// "Exclusive Deals" — fixed-width (344px) ticket cards in a native scroll-snap
// track (clamps cleanly at both ends, no trailing empty space).
export default function ExclusiveDeals() {
  return (
    <section className="v2-section" id="exclusive-deals-v2">
      <SectionHeader title="Exclusive Deals" subtitle="Limited-time offers you shouldn't miss." viewAllHref="/web" />
      <ScrollCarousel trackClassName="v2-deals__track" step={360}>
        {DEALS.map((deal) => (
          <div key={deal.id} className="v2-deal-card">
            <span className="v2-deal-card__deco" aria-hidden="true" />
            <div className="v2-deal-card__headline">{deal.headline}</div>
            <span className="v2-deal-card__perf" aria-hidden="true" />
            <div className="v2-deal-card__body">
              <h3>{deal.title}</h3>
              <p>{deal.subtitle}</p>
              <Button className="v2-deal-card__cta" size="small">{deal.cta}</Button>
            </div>
          </div>
        ))}
      </ScrollCarousel>
    </section>
  );
}
